<template>
  <div id="app">
    <nav-bar></nav-bar>

    <router-view></router-view>

    <collection></collection>
  </div>
</template>

<script>
import NavBar from './components/nav/NavBar'
import Collection from './components/Collection'

export default {
  name: 'App',
  components: {
    NavBar,
    Collection
  },
  created () {
    this.$store.dispatch('fetchItems', { self: this })
    if (this.$store.getters.isLoggedIn)
      this.$store.dispatch('getAccountData', { self: this })
  }
}
</script>

<style lang="scss">
  @import '~bulma/bulma.sass';

  body {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
  }

  @media screen and (min-device-width: 600px) {
    body {
      padding: 3.25rem;
    }
  }

  #main {
    flex: 1;
  }

  .modal-background {
    padding: 25px;
  }

  .observablehq:not(:first-child) {
    display: none;
  }

  .footer {
    background-color: #fff;
    padding: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue